"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.m19SingleDeselect = exports.m19SingleSelect = exports.m19Deselection = exports.m19Selection = exports.multiDeselect = exports.multiSelect = void 0;
var multiSelect = {
    artifactId: 10344,
    code: {
        procedure_code: "73030",
        units: 1,
        automate: true,
        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c42",
        evidence: [
            {
                feature: {
                    uuid: "ccb5dc26-210e-4bdc-afae-20758be67410",
                    type: "ngram",
                    ngram: "No endoleaks are detected",
                    slop: 1,
                    in_order: true,
                    display: true,
                    field: "raw_body",
                    spans: [
                        {
                            start: 812,
                            end: 837,
                            uuid: "cce97bb3-9d74-4d1f-b0e3-095dd583ddc3",
                            document_id: 234325,
                            content: "No endoleaks are detected sentence",
                            level: "sentence",
                            hash: "812-837-73030"
                        }
                    ]
                },
                type: "ngram",
                score: 1.8524357683146013
            }
        ],
        modifiers: {
            evidence: [],
            automate: true,
            codes: [
                {
                    uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca1",
                    modifier_code: "LT",
                    automate: true,
                    confidence: 0.99,
                    evidence: []
                }
            ]
        },
        diagnoses: {
            evidence: [],
            codes: [
                {
                    uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca2",
                    diagnosis_code: "M19.012",
                    confidence: 0.59,
                    automate: true,
                    evidence: [
                        {
                            feature: {
                                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c83",
                                type: "categorical",
                                category: "Spine",
                                field: "body_region"
                            },
                            type: "categorical",
                            score: 0.04377880184331798
                        },
                        {
                            feature: {
                                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c66",
                                type: "categorical",
                                category: "PET",
                                field: "procedure_category"
                            },
                            type: "categorical",
                            score: 0.23316912972085382
                        },
                        {
                            feature: {
                                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c55",
                                type: "ngram",
                                ngram: "dome of the diaphragm",
                                slop: 1,
                                in_order: true,
                                display: true,
                                field: "raw_body",
                                spans: [
                                    {
                                        start: 0,
                                        end: 49,
                                        content: "Mildly increased uptake associated with the posterior aspect of the posterior gastric wall, not entirely specific but without definite CT correlate but could be correlated with endoscopy given the lymphoma variant. ",
                                        uuid: "7797bb3-9d74-4d1f-b0e3-095ff583ddc3",
                                        document_id: 234325,
                                        level: "sentence",
                                        hash: "0-49-M19.012"
                                    }
                                ]
                            },
                            type: "ngram",
                            score: 1.8524357683146013
                        },
                        {
                            type: "categorical",
                            score: 1.8524357683146013,
                            feature: {
                                uuid: "7320815d-1a42-4155-abf3-e98b6d2496af",
                                type: "categorical",
                                field: "reason_for_visit",
                                category: "fever, cough"
                            }
                        }
                    ]
                },
                {
                    confidence: 0.9900000000000001,
                    uuid: "c7cc349b-b62a-4951-8da8-3568876e0c41",
                    diagnosis_code: "R60.0",
                    automate: true,
                    evidence: [
                        {
                            feature: {
                                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c38",
                                type: "prior"
                            },
                            type: "prior",
                            score: -0.00001054492930037871
                        },
                        {
                            feature: {
                                uuid: "c7cc349b-b62a-4951-8da8-35688768888",
                                type: "categorical",
                                category: "OB Ultrasound",
                                field: "procedure_type"
                            },
                            type: "categorical",
                            score: 0.019858258340373337
                        },
                        {
                            type: "categorical",
                            score: 0.007440717499160134,
                            feature: {
                                uuid: "9df1860d-d1c7-4fff-b7e1-1d3ee3bec8b9",
                                type: "categorical",
                                field: "exam_description",
                                category: "BI MAMMOGRAM SCREENING WITH TOMOSYNTHESIS WITH CAD (BILATERAL)"
                            }
                        },
                        {
                            feature: {
                                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c40",
                                type: "ngram",
                                ngram: "dome of the diaphragm",
                                slop: 1,
                                in_order: true,
                                display: true,
                                field: "raw_body",
                                spans: [
                                    {
                                        start: 0,
                                        end: 49,
                                        content: "Helically acquired axial images from the dome of the diaphragm",
                                        uuid: "7797bb3-9d74-4d1f-b0e3-095hh583ddc3",
                                        document_id: 234325,
                                        level: "sentence",
                                        hash: "0-49-R60.0"
                                    }
                                ]
                            },
                            type: "ngram",
                            score: 1.8524357683146013
                        },
                        {
                            feature: {
                                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c40",
                                type: "ngram",
                                ngram: "dome of the diaphragm",
                                slop: 1,
                                in_order: true,
                                display: true,
                                field: "raw_body",
                                spans: [
                                    {
                                        start: 118,
                                        end: 214,
                                        content: "Helically acquired axial images from the dome of the diaphragm",
                                        document_id: 234325,
                                        level: "sentence",
                                        uuid: "7797bb3-9d74-4d1f-b0e3-095bb583ddc7",
                                        hash: "118-214-R60.0"
                                    }
                                ]
                            },
                            type: "ngram",
                            score: 1.8524357683146013
                        }
                    ]
                }
            ]
        }
    },
    codeType: "cpt",
    evidence: [
        {
            feature: {
                uuid: "ccb5dc26-210e-4bdc-afae-20758be67410",
                type: "ngram",
                ngram: "No endoleaks are detected",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 812,
                        end: 837,
                        uuid: "cce97bb3-9d74-4d1f-b0e3-095dd583ddc3",
                        document_id: 234325,
                        content: "No endoleaks are detected sentence",
                        level: "sentence",
                        hash: "812-837-73030"
                    }
                ]
            },
            type: "ngram",
            score: 1.8524357683146013
        }
    ],
    display: true
};
exports.multiSelect = multiSelect;
var multiDeselect = __assign(__assign({}, multiSelect), { display: false });
exports.multiDeselect = multiDeselect;
var m19Selection = {
    artifactId: 55523,
    code: {
        uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca2",
        diagnosis_code: "M19.012",
        confidence: 0.59,
        automate: true,
        evidence: [
            {
                feature: {
                    uuid: "c7cc349b-b62a-4951-8da8-3568876e0c83",
                    type: "categorical",
                    category: "Spine",
                    field: "body_region"
                },
                type: "categorical",
                score: 0.04377880184331798
            },
            {
                feature: {
                    uuid: "c7cc349b-b62a-4951-8da8-3568876e0c66",
                    type: "categorical",
                    category: "PET",
                    field: "procedure_category"
                },
                type: "categorical",
                score: 0.23316912972085382
            },
            {
                feature: {
                    uuid: "c7cc349b-b62a-4951-8da8-3568876e0c55",
                    type: "ngram",
                    ngram: "dome of the diaphragm",
                    slop: 1,
                    in_order: true,
                    display: true,
                    field: "raw_body",
                    spans: [
                        {
                            start: 0,
                            end: 49,
                            content: "Mildly increased uptake associated with the posterior aspect of the posterior gastric wall, not entirely specific but without definite CT correlate but could be correlated with endoscopy given the lymphoma variant. ",
                            uuid: "7797bb3-9d74-4d1f-b0e3-095ff583ddc3",
                            document_id: 234325,
                            level: "sentence",
                            hash: "0-49-M19.012"
                        }
                    ]
                },
                type: "ngram",
                score: 1.8524357683146013
            },
            {
                type: "categorical",
                score: 1.8524357683146013,
                feature: {
                    uuid: "22bc9707-e98f-4be9-965a-a158ac69f0b9",
                    type: "categorical",
                    field: "reason_for_visit",
                    category: "fever, cough"
                }
            }
        ]
    },
    codeType: "icd",
    evidence: [
        {
            feature: {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c83",
                type: "categorical",
                category: "Spine",
                field: "body_region"
            },
            type: "categorical",
            score: 0.04377880184331798
        },
        {
            feature: {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c66",
                type: "categorical",
                category: "PET",
                field: "procedure_category"
            },
            type: "categorical",
            score: 0.23316912972085382
        },
        {
            feature: {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c55",
                type: "ngram",
                ngram: "dome of the diaphragm",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 0,
                        end: 49,
                        content: "Mildly increased uptake associated with the posterior aspect of the posterior gastric wall, not entirely specific but without definite CT correlate but could be correlated with endoscopy given the lymphoma variant. ",
                        uuid: "7797bb3-9d74-4d1f-b0e3-095ff583ddc3",
                        document_id: 234325,
                        level: "sentence",
                        hash: "0-49-M19.012"
                    }
                ]
            },
            type: "ngram",
            score: 1.8524357683146013
        },
        {
            type: "categorical",
            score: 1.8524357683146013,
            feature: {
                uuid: "22bc9707-e98f-4be9-965a-a158ac69f0b9",
                type: "categorical",
                field: "reason_for_visit",
                category: "fever, cough"
            }
        }
    ],
    display: true
};
exports.m19Selection = m19Selection;
var m19Deselection = __assign(__assign({}, m19Selection), { display: false });
exports.m19Deselection = m19Deselection;
var m19SingleSelect = {
    artifactId: 55523,
    display: true,
    evidence: {
        feature: {
            uuid: "c7cc349b-b62a-4951-8da8-3568876e0c55",
            type: "ngram",
            ngram: "dome of the diaphragm",
            slop: 1,
            in_order: true,
            display: true,
            field: "raw_body",
            spans: [
                {
                    start: 0,
                    end: 49,
                    content: "Mildly increased uptake associated with the posterior aspect of the posterior gastric wall, not entirely specific but without definite CT correlate but could be correlated with endoscopy given the lymphoma variant. ",
                    uuid: "7797bb3-9d74-4d1f-b0e3-095ff583ddc3",
                    document_id: 234325,
                    level: "sentence",
                    hash: "0-49-M19.012"
                }
            ]
        },
        type: "ngram",
        score: 1.8524357683146013
    },
    codeType: "icd",
    code: {
        uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca2",
        diagnosis_code: "M19.012",
        confidence: 0.59,
        automate: true,
        evidence: [
            {
                feature: {
                    uuid: "c7cc349b-b62a-4951-8da8-3568876e0c83",
                    type: "categorical",
                    category: "Spine",
                    field: "body_region"
                },
                type: "categorical",
                score: 0.04377880184331798
            },
            {
                feature: {
                    uuid: "c7cc349b-b62a-4951-8da8-3568876e0c66",
                    type: "categorical",
                    category: "PET",
                    field: "procedure_category"
                },
                type: "categorical",
                score: 0.23316912972085382
            },
            {
                feature: {
                    uuid: "c7cc349b-b62a-4951-8da8-3568876e0c55",
                    type: "ngram",
                    ngram: "dome of the diaphragm",
                    slop: 1,
                    in_order: true,
                    display: true,
                    field: "raw_body",
                    spans: [
                        {
                            start: 0,
                            end: 49,
                            content: "Mildly increased uptake associated with the posterior aspect of the posterior gastric wall, not entirely specific but without definite CT correlate but could be correlated with endoscopy given the lymphoma variant. ",
                            uuid: "7797bb3-9d74-4d1f-b0e3-095ff583ddc3",
                            document_id: 234325,
                            level: "sentence",
                            hash: "0-49-M19.012"
                        }
                    ]
                },
                type: "ngram",
                score: 1.8524357683146013
            },
            {
                type: "categorical",
                score: 1.8524357683146013,
                feature: {
                    uuid: "22bc9707-e98f-4be9-965a-a158ac69f0b9",
                    type: "categorical",
                    field: "reason_for_visit",
                    category: "fever, cough"
                }
            }
        ]
    }
};
exports.m19SingleSelect = m19SingleSelect;
var m19SingleDeselect = __assign(__assign({}, m19SingleSelect), { display: false });
exports.m19SingleDeselect = m19SingleDeselect;
//# sourceMappingURL=selections.fixtures.js.map